class cAdminAnnouncements {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elAnnouncementTable = $('#announcement-table');


        $(elAnnouncementTable).dataTable({
            'paging': true,
            'ordering': true,
            'pageLength': 100,
            'lengthMenu': [50, 100, 200, 500],
            'info': true,
            'order': [[3, 'desc']],
            'columnDefs': [
                { "orderable": false, "targets": [0] }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Announcements Ranges per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
}
